export { default as outputs } from './outputs/prod/amplify_outputs.json';
